import React from 'react';
import { Checkbox } from 'antd';
import { useFieldController } from '../../../helpers/formManager';
import FormFieldItem from './FormFieldItem';
import { fieldNames } from '../constants';

const IsOwnerField = ({ control }) => {
  const {
    field: { value, onChange },
  } = useFieldController({ control, name: fieldNames.isOwner });

  return (
    <FormFieldItem>
      <Checkbox
        checked={value}
        onChange={(event) => onChange(event.target.checked)}
      >
        Собственник
      </Checkbox>
    </FormFieldItem>
  );
};

export default IsOwnerField;
